import { render, staticRenderFns } from "./mvPopUpProductPrompt.vue?vue&type=template&id=58a8f59a&scoped=true"
import script from "./mvPopUpProductPrompt.vue?vue&type=script&lang=js"
export * from "./mvPopUpProductPrompt.vue?vue&type=script&lang=js"
import style0 from "./mvPopUpProductPrompt.vue?vue&type=style&index=0&id=58a8f59a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a8f59a",
  null
  
)

export default component.exports